import FJMobileImageToImageEdit from './FJMobileImageToImageEdit';
import { useSelector, useDispatch } from 'react-redux';
import { setSlicePromptAction } from '../../../redux/slices/FJSliceImageToImage';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import useLocalStore from '../../../hooks/useLocalStore';
import { useCallback } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJActionCommon from '../../../redux/action/FJActionCommon';

const FJMobileImageToImageEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const prompt = useSelector(state => state.imageToImage.prompt);
    const uploadImageInfo = useSelector(state => state.imageToImage.uploadImageInfo);
    const generateQuantity = useSelector(state => state.imageToImage.generateQuantity);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);

    const changePrompt = value => {
        dispatch(setSlicePromptAction(value));
    };
    const uploadImg = file => {
        dispatch(FJActionImageToImage.uploadImageAction(file));
    };
    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageToImage.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(0));
    }, [dispatch, taskStatus]);

    return (
        <FJMobileImageToImageEdit
            prompt={prompt}
            uploadImageInfo={uploadImageInfo}
            changePrompt={changePrompt}
            uploadImg={uploadImg}
            generateQuantity={generateQuantity}
            onGenerate={_onGenerate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            isProjectLoading={isProjectLoading}
        />
    );
};
export default FJMobileImageToImageEditContainer;
